import React from 'react';

import i18n from 'i18next';
import { Typo } from 'uikit/content';
import { Form } from 'core/forms';
import NewItemFormButtons from './newItemFormButtons';

import getCurrentTimeString from '../helpers/getCurrentTimeString';
import getAnnouncementSchema from '../schemas/getAnnouncementSchema';

import styles from '../styles/sendAnnouncement.module.scss';

const SendAnnouncement = ({
  hasError,
  hasUrlTextInput,
  isEditing,
  isSubmitting,
  model,
  onCancel,
  onLoad,
  onSubmit,
  onUpdate,
}) => {
  const image = model.challenge_picture;

  return (
    <>
      <div className={styles.element}>
        {isEditing ? (
          <Form
            model={model}
            onLoad={onLoad}
            onUpdate={onUpdate}
            schema={getAnnouncementSchema(model, hasUrlTextInput)}
          />
        ) : (
          <div className={styles.preview}>
            <div className={styles.header}>
              <Typo color="secondary" variant="s01">
                {i18n.t('announcement')}
              </Typo>
              <Typo color="secondary" variant="s01">
                {getCurrentTimeString()}
              </Typo>
            </div>
            <div className={styles.content}>
              {image && (
                <div
                  className={styles.image}
                  style={{ backgroundImage: image && `url(${image})` }}
                />
              )}
              <div className={styles.textContainer}>
                <Typo variant="d01">{model.subject}</Typo>
                <Typo color="secondary" variant="b01">
                  {model.message}
                </Typo>
              </div>
            </div>
          </div>
        )}
      </div>
      <NewItemFormButtons
        isFullScreen={false}
        cancelText={isEditing ? i18n.t('cancel') : i18n.t('edit')}
        hasError={hasError}
        isSubmitting={isSubmitting}
        onCancel={onCancel}
        onSubmit={onSubmit}
        submitText={isEditing ? i18n.t('preview') : i18n.t('send-announcement-submit')}
      />
    </>
  );
};

export default React.memo(SendAnnouncement);
